import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import icons from './../../icons.svg';

const Overlay = styled.div`
  background-color: rgba(255, 255, 255, 1);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

const Delay = styled.div`
  margin-left: 15px;
  margin-right: 15px;
`;

const Progress = styled.div`
  margin-top: 100px;
  text-align: center;
`;

const BusyOverlay = ({ t, message = 'please_wait_for_door_open' }) => {
  return (
    <Overlay>
      <Delay>
        <Progress>
          <p>{t(message)}</p>
          <div className="loading-container">
            <svg className="loading">
              <use xlinkHref={`${icons}#icon-refresh`}></use>
            </svg>
          </div>
        </Progress>
      </Delay>
    </Overlay>
  );
};

export default translate('common')(BusyOverlay);
